<template>
    <div class="row">
        <div class="col-12 mb-3">
            <div class="card">
                <form class="card-body" @submit.prevent="UPDATE_FEL()">
                    <div>
                        <h5>Detalles de facturación</h5>
                        <p>Para cambiar tus datos de facturación, edítalo y guárdalo desde aquí</p>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group mb-2">
                                <small class="input-title">Tipo de cuenta</small>
                                <v-select v-model="data.account_type"
                                    :items="accounts.filter(e => e.value > 0)"
                                    @change="CHANGE"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.account_type ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.account_type" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-2" v-if="data.account_type == 2">
                                <small class="input-title">Nombre de la Empresa</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.company" :class="errors.company ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.company" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2" v-if="data.account_type != 2">
                                <small class="input-title">Nombre</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.first_name" :class="errors.first_name ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.first_name" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2" v-if="data.account_type != 2">
                                <small class="input-title">Apellido</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.last_name" :class="errors.last_name ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.last_name" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Tipo de Identificación</small>
                                <v-select v-model="data.identification_type"
                                    :items="identifications.filter((e) => data.account_type == 2 ? e.value == 2 : e.value != 2)"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.identification_type ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.identification_type" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Identificación</small>
                                <input type="text" class="form-control form-control-sm" v-mask="format" v-model="data.identification" :class="errors.identification ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.identification" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Factura Electrónica</small>
                                <v-select v-model="data.fel"
                                    :items="options"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.fel ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.fel" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-3">
                                <small class="input-title">Correo Electrónico(Factura Electrónica): </small>
                                <input type="email" :disabled="data.fel !== 1" class="form-control form-control-sm" v-model="data.email_fel" :class="errors.email_fel ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.email_fel" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <button class="btn btn-success btn-sm">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'user',
            'accounts',
        ]),
        format: function(){
            let format = ''
            if(this.data.identification_type == 1){
                format = '0#-####-####'
            } else if(this.data.identification_type == 2){
                format = '3-###-######'
            } else if(this.data.identification_type == 3){
                format = '1############'
            } else {
                format = '9#################'
            }
            return format
        }
    },
    data () {
        return {
            data: {},
            errors: {},
            options: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            identifications: [
                { value: 1, text: 'Cédula Nacional' },
                { value: 2, text: 'Cédula Juridica' },
                { value: 3, text: 'Cédula de Residencia (DIMEX)' },
                { value: 4, text: 'Pasaporte' },
            ],
            count: 0
        }
    },
    created () {
        let vue = this
        vue.data = vue.user
    },
    methods: {
        CHANGE: function () {
            let data = this.identifications.filter((e) => this.data.account_type == 2 ? e.value == 2 : e.value != 2)
            this.data.identification_type = data.findIndex((e) => e.value == this.data.identification_type) != -1 ? this.data.identification_type : data[0].value
        },
        UPDATE_FEL: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                let data = {
                    account_type: vue.data.account_type,
                    company: vue.data.company,
                    first_name: vue.data.first_name,
                    last_name: vue.data.last_name,
                    identification_type: vue.data.identification_type,
                    identification: vue.data.identification,
                    fel: vue.data.fel,
                    email_fel: vue.data.email_fel,
                    option: 3
                }
                setTimeout(() => {
                    axios({url: '/me', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$store.dispatch('PROFILE', resp.data.data)
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        },
    }
}
</script>